import { render, staticRenderFns } from "./_acceptance_rule_form.vue?vue&type=template&id=5c544f2e&"
import script from "./_acceptance_rule_form.vue?vue&type=script&lang=js&"
export * from "./_acceptance_rule_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports